export default __webpack_public_path__ + "static/media/beforeafter@2x.09c258d7.png";